export default "__VITE_ASSET__BRhNKoyK__";